// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3jaLo","field":"styles_field__12Nn5","fieldCol":"styles_fieldCol__pmHZl","diffCol":"styles_diffCol__m83Na","diff":"styles_diff__3jrhm"};